/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (effect selectors) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
import { createSelector } from '@reduxjs/toolkit'

/** The `live` slice root. Exported through `~/store/live/selectors`, which is where consumers import it from. */
export const selectLive = s => s.live

export const selectDiffusionParams = createSelector(selectLive, l => l.diffusion)
export const selectMotionParams = createSelector(selectLive, l => l.motion)
export const selectControlParams = createSelector(selectLive, l => l.control)
export const selectIpParams = createSelector(selectLive, l => l.ip)
export const selectFilterParams = createSelector(selectLive, l => l.filter)
export const selectInpaintParams = createSelector(selectLive, l => l.inpaint)
